import React from 'react';
import TimePicker, { Props } from '.';
import { FieldRenderProps } from 'react-final-form';

export default ((props: FieldRenderProps<Props, HTMLInputElement> & Props) => {
  const { input, meta, ...rest } = props;
  return <TimePicker {...input} {...rest} />;
}) as React.FC<FieldRenderProps<Props, HTMLInputElement> & Props>;
